module.exports = __webpack_public_path__ + "media/images/flags/tc-28940ce079320151a8c6841dd6665754.svg";